exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**  rel=\"stylesheet/scss\" lang=\"scss\"*/\n/** backgroud */\n/** border */\n/** table */\n/* Popover\n-------------------------- */\n/* Dialog\n-------------------------- */\n[data-v-065a26c2]:export {\n  xrColorPrimary: #2362FB;\n}\n.wk-form-items[data-v-065a26c2] {\n  padding: 0 12px;\n}\n", ""]);

// exports
